export const LOCATION_STATE = 'location'

export const FETCH_LOCATION_SUCCESS = 'FETCH_LOCATION_SUCCESS'
export const FETCH_LOCATION_FAILED = 'FETCH_LOCATION_FAILED'
